<div class="content-container">
	<h3 class="add-device-title">{{ addDeviceDetailTitle }}</h3>
	<div class="add-device-description">
		{{ addDeviceDetailDescription }}
	</div>
	<mat-form-field
		subscriptSizing="dynamic"
		class="column textarea-dimensions thin-outline-input-field"
		appearance="outline"
	>
		<textarea
			#txtarea
			matInput
			rows="10"
			appNumericInput
			placeholder="Serial Numbers"
			class="textarea-serial-numbers"
			[(ngModel)]="txtSerialNumber"
			i18n-placeholder="@@addDeviceDetail-serialNumberPlaceholder"
		>
		</textarea>
	</mat-form-field>
</div>
